import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/api';
import PageTitle from '../components/pageTitle';
import './passwordReset.css';

const ResetPasswordPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const submit = async (event) => {
        event.preventDefault();
        setError('');
        if (password !== confirmation) {
            setError('The passwords do not match.');
            return;
        }
        setSubmitting(true);
        try {
            await api.post('/user/reset-password', { token, password });
            setSuccess(true);
            setPassword('');
            setConfirmation('');
        } catch (requestError) {
            setError(requestError?.response?.data?.error || 'Unable to reset the password right now.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <PageTitle title="Choose a new password" />
            <main className="auth-shell password-reset-page">
                <section className="auth-card">
                    <header className="auth-header">
                        <h3>Choose a new password</h3>
                        <p>Use at least 8 characters for your new password.</p>
                    </header>
                    {success ? (
                        <div className="password-reset-result" role="status">
                            <p>Your password has been reset. You can now log in.</p>
                            <Link to="/login" className="auth-inline-link">Go to log in</Link>
                        </div>
                    ) : !token ? (
                        <div className="password-reset-result" role="alert">
                            <p>This password reset link is invalid or has expired.</p>
                            <Link to="/forgot-password" className="auth-inline-link">Request another link</Link>
                        </div>
                    ) : (
                        <form className="auth-form" onSubmit={submit}>
                            <div className="user-input-area auth-fields">
                                <label className="auth-label" htmlFor="new-password">New password</label>
                                <input
                                    id="new-password"
                                    className="text-input-generic primary-font password-reset-input"
                                    type="password"
                                    autoComplete="new-password"
                                    minLength={8}
                                    maxLength={128}
                                    required
                                    value={password}
                                    onChange={(event) => setPassword(event.target.value)}
                                />
                                <label className="auth-label" htmlFor="confirm-password">Confirm password</label>
                                <input
                                    id="confirm-password"
                                    className="text-input-generic primary-font password-reset-input"
                                    type="password"
                                    autoComplete="new-password"
                                    minLength={8}
                                    maxLength={128}
                                    required
                                    value={confirmation}
                                    onChange={(event) => setConfirmation(event.target.value)}
                                />
                            </div>
                            {error && <p className="password-reset-error" role="alert">{error}</p>}
                            <div className="auth-actions auth-actions-spread password-reset-actions">
                                <Link to="/forgot-password" className="auth-inline-link">Request another link</Link>
                                <button className="button-primary primary-bg primary-font" type="submit" disabled={submitting}>
                                    {submitting ? 'Updating...' : 'Update password'}
                                </button>
                            </div>
                        </form>
                    )}
                </section>
            </main>
        </>
    );
};

export default ResetPasswordPage;